import FeedIcon from '@mui/icons-material/Feed';
import { LayoutModule } from '../../../../layout/modules';
import { FinalCausalityDetailActions } from './actions';
import { useFinalCausalityDetail } from './hook';
import { FinalCausalityRegisterHistory } from './registerHistory';
import { FinalCausalityData } from './data';
import { isTrainerOrQuality } from '../../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';

export const FinalCausalityDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const { finalCausality, loading } = useFinalCausalityDetail();

    const additionalButtons = !isTrainerOrQuality(type) ? (
        <FinalCausalityDetailActions
            finalCausalityId={finalCausality?.id || ''}
        />
    ) : undefined;

    return (
        <>
            <LayoutModule
                title="Detalle causalidad final"
                titleChildren="Información general"
                icon={<FeedIcon sx={{ color: 'primary.main' }} />}
                additionalButtons={additionalButtons}
            >
                <FinalCausalityData
                    finalCausality={finalCausality}
                    loading={loading}
                />
            </LayoutModule>
            <FinalCausalityRegisterHistory finalCausality={finalCausality} />
        </>
    );
};
